import { IAPIBody } from './IAPIBody';

export class NodeBody implements IAPIBody {
    public Url: string = "";

    public constructor(url: string) {
        this.Url = url;
    }
}